<div
    *transloco="let t"
    class="bazis-signed-file-inline"
>
    <div class="bazis-file-inline">
        <bazis-badge
            color="danger"
            size="large"
        >
            {{ extension() }}
        </bazis-badge>

        @if (srcFile()) {
        <span class="bazis-list bazis-list_short-info">
            <span class="bazis-item">
                <bazis-link
                    class="bazis-file-inline__file"
                    borderStyle="none"
                    [href]="hasLink() ? srcFile() : undefined"
                    [target]="hasLink() ? '_blank' : '_self'"
                    [title]="
                        t(fileNameKey(), fileNameParams()) ||
                        filesData().displayDocument.$snapshot.name
                    "
                >
                    {{
                        t(fileNameKey(), fileNameParams()) ||
                            filesData().displayDocument.$snapshot.name
                    }}
                </bazis-link>
            </span>

            @if (showFileSize()) {
            <span class="bazis-item">
                <span>
                    {{ filesData().displayDocument.$snapshot.size | fileSize }}
                </span>
                @if (tooltipKey()) {
                <span #tooltipTarget>
                    &nbsp;
                    <bazis-icon
                        name="interrogation"
                        size="compact"
                    ></bazis-icon>
                    <bazis-tooltip
                        [reference]="tooltipTarget"
                        placement="top-end"
                        [isStatic]="false"
                        [offset]="[8, 4]"
                        class="bh-popper-z-index"
                    >
                        {{ t(tooltipKey(), tooltipParams()) }}
                    </bazis-tooltip>
                </span>
                }
            </span>
            }
        </span>
        }
    </div>

    @if (showSignatures() && filesData().signInfo.$snapshot.signatories?.length > 0) {
    <!-- show signatures if they exist in file entity and required by parent component -->
    <bazis-button
        fill="clear"
        size="compact"
        class="bh-hide-xl-down"
        (click)="openSignatureDetails()"
    >
        <bazis-icon
            slot="icon-only"
            src="/assets/icons/other/key.svg"
        ></bazis-icon>
    </bazis-button>
    <bazis-button
        size="compact"
        fill="clear"
        class="bh-hide-xl-down"
    >
        <bazis-link
            slot="icon-only"
            borderStyle="none"
            [href]="filesData().displayDocument.$snapshot.file_upload_url"
            [download]="filesData().displayDocument.$snapshot.name"
            target="_blank"
        >
            <bazis-icon name="download"></bazis-icon>
        </bazis-link>
    </bazis-button>

    <div class="bazis-dropdown bh-hide-xl-up">
        <bazis-button
            class="bazis-dropdown__trigger"
            fill="clear"
            size="compact"
            (click)="toggleMenu($event)"
        >
            <bazis-icon
                slot="icon-only"
                name="menu-dots"
                size="regular"
            ></bazis-icon>
        </bazis-button>

        @if (openDropdownMenu) {
        <div class="bazis-dropdown__body">
            <div class="bazis-list bazis-list_select">
                <bazis-button
                    class="bazis-item"
                    (click)="openSignatureDetails()"
                >
                    {{ t('action.openSignatures') }}
                </bazis-button>
                <a
                    [href]="filesData().displayDocument.$snapshot.file_upload_url"
                    [download]="filesData().displayDocument.$snapshot.name"
                    target="_blank"
                    class="bazis-item"
                >
                    {{ t('action.download') }}
                </a>
            </div>
        </div>
        }
    </div>
    }
</div>
